export default {
  state: {
    instance: null
  },
  mutations: {
    TRACKER_SET_INSTANCE(state, data) {
      state.instance = data
    }
  },
  actions: {
    TRACKER_INIT({ commit }, instance) {
      commit('TRACKER_SET_INSTANCE', instance)
    },
    TRACKER_SEND_EVENT({ state }, data) {
      if (state.instance && typeof state.instance.event === 'function') {
        state.instance.event(data.action, { event_category: data.category, event_label: data.label })
      }
    }
  }
}
